import Head from 'next/head'
import type {FC} from 'react'

const BASE_URL = process.env.NEXT_PUBLIC_APP_URL || 'https://www.getmoss.com'

type PaginationSEOProps = {
  currentPage: number
  totalPages: number
  baseUrl: string
  locale?: string
}

export const PaginationSEO: FC<PaginationSEOProps> = ({currentPage, totalPages, baseUrl, locale}) => {
  if (currentPage <= 0 || totalPages <= 0) {
    return null
  }

  const buildPageUrl = (pageNumber: number): string => {
    const localePrefix = locale && locale !== 'en-us' ? `/${locale}` : ''

    if (pageNumber === 1) {
      return `${BASE_URL}${localePrefix}${baseUrl}`
    }

    return `${BASE_URL}${localePrefix}${baseUrl}/page/${pageNumber}`
  }

  return (
    <Head>
      <link rel="canonical" href={buildPageUrl(currentPage)} />
      {currentPage > 1 && <link rel="prev" href={buildPageUrl(currentPage - 1)} />}
      {currentPage < totalPages && <link rel="next" href={buildPageUrl(currentPage + 1)} />}
      {currentPage > 1 && <meta name="robots" content="noindex, follow" />}
    </Head>
  )
}
